/// <reference path="../../typings/index.d.ts" />

import {DataStore} from './DataStore';
import {Popup} from './Popup';
import {showAktiviteter} from './GridAktiviteter';
import { Utils } from '../Utils';
import * as _ from "underscore";
import { PlanTab } from "./PlanTab";

export class GridPlanner {
    static selskapId: number;
    static grid: DevExpress.ui.dxDataGrid;
    static popup: Popup;

    public static showPlanner(container, options) {
        var selskapId = options.data.id;
        GridPlanner.selskapId = selskapId;

        container.addClass("internal-grid-container p10");
        $("<table>")
            .addClass("internal-grid-caption")
            .append(
                $("<tr>")
                    .append(
                        $("<td>").append("<i class='fa fa-sitemap mr-5'></i>Planer for " + options.data.beskrivelse)
                    )
                    .append(
                        $("<td>").addClass("pl20").append("<div id='add" + selskapId + "'></div>")
                    )
            ).appendTo(container);

        var myself: GridPlanner = this;
        $.getJSON("/Data/Plan", { selskapId }, function (data) {
            //debugger;
            var gridDiv = $('<div>')
                .addClass("internal-grid")
                .dxDataGrid({
                    rowAlternationEnabled: true,
                    columnAutoWidth: true,
                    dataSource: data, //DataStore.newStore("/Data/Plan", { selskapId }),
                    filterRow: {
                        visible: true,
                        applyFilter: "auto"
                    },
                    headerFilter: {
                        visible: true
                    },
                    selection: {
                        mode: "single"
                    },
                    grouping: {
                        autoExpandAll: false
                    },
                    groupPanel: {
                        visible: true
                    },
                    showBorders: true,
                    onRowClick: (e) => {
                        var component3 = e.component, prevClickTime3 = component3.lastClickTime;
                        component3.lastClickTime = new Date();
                        if (prevClickTime3 && (component3.lastClickTime - prevClickTime3 < 300)) {
                            //new openPlanEditor(selskapId, e.data.navn, e.data, GridPlanner.grid);
                            new PlanTab(e.data);
                        }
                    },
                    columns: [
                        {
                            dataField: 'id',
                            caption: 'Id',
                            width: 80
                        }, {
                            dataField: 'navn',
                            caption: 'Navn'
                        }, {
                            dataField: 'beskrivelse',
                            caption: 'Beskrivelse'
                        }, {
                            dataField: 'planType.beskrivelse',
                            caption: 'Plantype'
                        },
                        {
                            caption: 'År',
                            calculateCellValue: (e: any) => {
                                let sdato = new Date(e.startDato);
                                return sdato.getFullYear().toString();
                            },
                            allowGrouping: true,
                            allowSorting: true,
                            groupIndex: 0,
                            sortOrder: 'desc'
                        },
                        {
                            dataField: 'startDato',
                            caption: 'Startdato',
                            format: 'dd.MM.yyyy',
                            dataType: 'date',
                            width: 90
                        }, {
                            dataField: 'sluttDato',
                            caption: 'Sluttdato',
                            format: 'dd.MM.yyyy',
                            dataType: 'date',
                            width: 90
                        }, {
                            dataField: 'opperettetAvBruker.brukernavn',
                            caption: 'Opprettet av',
                            dataType: 'string'
                        }, {
                            dataField: 'status.navn',
                            caption: 'Status',
                            dataType: 'string'
                        },{
                            width: 100,
                            alignment: 'center',
                            cellTemplate: function (container, options, e) {
                                if (!options.data.godkjentDato) {
                                    $('<a/>').addClass('dx-link')
                                        .text('Edit')
                                        .on('dxclick', function () {
                                            new openPlanEditor(selskapId, options.data.navn, options.data, this.grid)
                                        })
                                        .appendTo(container);
                                } else {
                                    $('<div>').text("Godkjent").appendTo(container);
                                }

                            }
                        }
                    ],
                    masterDetail: {
                        enabled: true,
                        template: showAktiviteter
                    }
                });
            GridPlanner.grid = gridDiv.dxDataGrid("instance");
            $("#add" + selskapId).dxButton({
                text: "Ny plan...",
                icon: 'add',
                type: "default",
                onClick: () => new openPlanEditor(selskapId, options.data.navn, null, this.grid)
            });
            gridDiv.appendTo(container);
        });

    }

    public static refreshGrid() {
        $.getJSON("/Data/Plan", { selskapId: this.selskapId }, (data) => {
            GridPlanner.grid.option("dataSource", data);
            GridPlanner.grid.refresh();
        });
    }
}

class openPlanEditor {
    grid: DevExpress.ui.dxDataGrid;
    constructor(selskapId: number, name: string, plan: Object, grid: DevExpress.ui.dxDataGrid) {
        this.grid = grid;
        var self = this;
        let title = '<div class="p-header"><i class="fa fa-sitemap"></i>Legg til ny plan for ' + name + '</div>';
        if (plan) {
            title = '<div class="p-header"><i class="fa fa-sitemap"></i>Edit plan ' + name + '</div>';
        }
        let container = $("<div>");
            $("<div>").attr("id", "form").appendTo(container);
        $("<div style=\"height:1px; border-top:1px solid silver;margin-bottom:10px;margin-top:10px;\"/>").appendTo(container);
        let buttonContainer = $("<div>").css("float", "right");
            $("<div>").attr("id", "cancel").appendTo(buttonContainer);
            $("<div>").attr("id", "ok").appendTo(buttonContainer);
        buttonContainer.appendTo(container);
        var popupOptions = {
            width: 450,
            height: 385,
            contentTemplate: container,
            titleTemplate: title
        };
        if (plan !== null) {
            // Create godkjenne button if not editing
            popupOptions.height += 35;
            buttonContainer.append($("<div>").attr("id", "godkjenne"));
            $.get("/Account/IsAdmin")
                .done((isAdmin) => {
                    if (isAdmin)
                        buttonContainer.append($("<div>").attr("id", "delete"));
            })
            .always(() => {               
                this.createPlanForm(popupOptions, this.lagrePlan.bind(self), plan);
            });
        } else {           
            plan = { selskapId };
            this.createPlanForm(popupOptions, this.lagrePlan.bind(self), plan);
        }
    }

    lagrePlan(plan: any) {
        var self = this;
        Utils.fixDates(plan);
        
        $.post("/Data/Plan", plan)
        .done((success) => {
            DevExpress.ui.notify("Plan er lagret !", "success", 2000);
            GridPlanner.refreshGrid();
            GridPlanner.popup.hide(); 
        })
        .fail((xhr, textStatus, errorThrown) => {
            DevExpress.ui.notify("Plan er ikke lagret !", "error", 2000);
        });
    }

    createPlanForm(popupOptions: any, onSave: (n: Object) => any, initialData: Object) {
        var self = this;
        function validatePlanTemplate() {
            var result = <any>form.validate();
            if(result.isValid) {
                onSave(form.option("formData"));
            }
        }
        var planTemplate: Object = {
            "id": 0,
            "selskapId": null,
            "navn": "",
            "beskrivelse": "",
            "merknader": "",
            "statusId": 1,
            "planTypeId": 3,
            "startDato": null,
            "sluttDato": null,
            "opprettetAv": null,
            "opperettetAvBruker": null,
            "opprettetDato": null,
            "sistEndretAv": null,
            "sistEndretDato": null,
            "kontrollertAv": 0,
            "kontrollertDato": null,
            "godkjenttAv": 0,
            "godkjentDato": null,
        };
        if (initialData) {
            _.assign(planTemplate, initialData);
        }
        var infoItems = [
            {
                dataField: "navn",
                label: {
                    text: "Navn"
                },
                editorType: "dxTextBox",
                validationRules: [{
                    type: "required",
                    message: "Navn er påkrevet"
                }]
            }, {
                dataField: "beskrivelse",
                label: {
                    text: "Beskrivelse"
                },
                editorType: "dxTextBox",
                validationRules: [{
                    type: "required",
                    message: "Beskrivelse er påkrevet"
                }]
            }, {
                dataField: "planTypeId",
                label: {
                    text: "Plan type"
                },
                editorType: "dxSelectBox",
                editorOptions: {
                    dataSource: [],
                    valueExpr: "id",
                    displayExpr: "navn"
                },
                validationRules: [{
                    type: "required",
                    message: "Plan type er påkrevet"
                }]
            }, {
                dataField: "startDato",
                label: {
                    text: "Start dato"
                },
                editorType: "dxDateBox",
                editorOptions: {
                    width: "100%",
                    displayFormat: 'dd.MM.yyyy',
                    onClosed: (e) => {
                        //let frm = $("#form").dxForm("instance");
                        //var startDato: any = frm.getEditor("startDato");
                        //var sluttDato:any = frm.getEditor("sluttDato");
                        //var dato = new Date(startDato.option("value"));
                        //var newDate = dato.setDate(dato.getDate() + 30);                    
                        //sluttDato.option("value", newDate);
                        //frm.itemOption("sluttDato", "value", newDate);
                    }
                },
                validationRules: [{
                    type: "required", 
                    message: "Start dato er påkrevet"
                }]
            }, {
                dataField: "sluttDato",
                label: {
                    text: "Slutt dato"
                },
                editorType: "dxDateBox",
                editorOptions: {
                    width: "100%",
                    displayFormat: 'dd.MM.yyyy'
                },
                validationRules: [{
                    type: "required",
                    message: "Slutt dato er påkrevet"
                }]
            }, {
                dataField: "merknader",
                label: {
                    text: "Merknader"
                },
                editorType: "dxTextArea",
                editorOptions: {
                    height: 90
                }
            }, 
        ];
        GridPlanner.popup = new Popup(popupOptions);
        GridPlanner.popup.show();

        var form: DevExpress.ui.dxForm = $("#form").dxForm({
            formData: planTemplate,
            items: infoItems,
            onFieldDataChanged: () => {
                $("#godkjenne").dxButton("option", "disabled", true);
            }
        } as DevExpress.ui.dxFormOptions).dxForm("instance");

        $.get("/Data/PlanType", (data) => {
            let editor = <any>form.getEditor("planTypeId");
            editor.option("dataSource", data);
        });
        
        $("#delete").css({ "margin-top": "10px", "margin-left": "5px" })
        .dxButton({
            text: "Slett",
            type: "danger",
            height: 30,
            width: 200,
            icon: 'trash',
            onClick: () => {
                let container = $("<div>");
                    $("<div>").attr("id", "confirmation-no").appendTo(container);
                    $("<div>").attr("id", "confirmation-yes").appendTo(container);
                let popupContainer = $("<div>")
                .attr("id", "confirmation")
                .dxPopup({
                    height: 100,
                    width: 444,
                    contentTemplate: container,
                    title: "Er du sikker på at du vil slette planen?",
                    showCloseButton: false,
                    dragEnabled: false,
                    titleTemplate: () => $("<div>")
                                            .css({ "text-align": "center", "padding": "10px", "font-size": 18 })
                                            .text("Er du sikker på at du vil slette planen?")
                });
                popupContainer.appendTo($("body"));

                let popup = popupContainer.dxPopup("instance");

                popup.show();
                $("#confirmation-yes").dxButton({
                    text: "Ja",
                    type: "success",
                    width: 200,
                    height: 30,
                    onClick: () => {
                        $.post("/Data/DeletePlan", initialData)
                        .done(() => {
                            DevExpress.ui.notify("Plan slettet!", "success", 2000);
                            GridPlanner.refreshGrid();
                            GridPlanner.popup.hide(); // Hide edit popup window
                        })
                        .fail(() => {
                            DevExpress.ui.notify("Plan ikke slettet!", "error", 2000);
                        })
                        .always(() => {
                            popupContainer.remove(); // Hide confirmation dialog
                        });
                    }
                });
                $("#confirmation-no").dxButton({
                    text: "Nei",
                    type: "normal",
                    width: 200,
                    height: 30,
                    onClick: () => {
                        popupContainer.remove();
                    }
                });
            }
            });

        $("#godkjenne").css({ "margin-top": "10px", "margin-left": "5px" })
        .dxButton({
            text: "Godkjenne",
            type: "default",
            height: 30,
            width: 200,
            icon: 'bookmark',
            onClick: function () {
                $.post("/Data/GodkjennePlan",initialData)
                .done(() => {
                    DevExpress.ui.notify("Plan godkjennt!", "success", 2000);
                    GridPlanner.refreshGrid();
                    GridPlanner.popup.hide(); // Hide edit popup window
                })
                .fail(() => {
                    DevExpress.ui.notify("Plan kan ikke godkjennes - Noen aktiviteter er ikke kontrollert!", "error", 2000);
                })
                .always(() => {
                });
            }
        });

        $("#cancel").dxButton({
            text: "Avbryt",
            height: 30,
            width: 200,
            icon: 'close',
            onClick: function () {
                GridPlanner.popup.hide();
            }
        });

        $("#ok").dxButton({
            text: "Lagre",
            type: "success",
            icon: "save",
            height: 30,
            width: 200,
            onClick: validatePlanTemplate
        });
    }
}


// WEBPACK FOOTER //
// ./TS/Plan/GridPlanner.ts